import Send from "../communication"

export const getBeneficiaryJourney = async (
  scopeId,
  scopeType, 
  currentUserRole, 
  usersProject
) => {
  try {
    const query = `/bigquery/status/kanban/${scopeId}`
    const data = await Send.get(`${query}`, `scopeType=${scopeType}`)

    if (!Array.isArray(data) || data.length === 0) return {}

    // Mapeamento dos buckets do SQL para os campos do frontend
    const bucketMapping = {
      "Desconexão": "desconexao",
      "Cadastrados recentemente": "recentes",
      "Prospecção": "prospeccao",
      "Nutrição": "nutricao",
      "Engajados": "engajamento",
      "Com coleta": "coleta",
      "Com agendamento": "agendamento",
      "Com atendimento": "atendimento"
    }

    // Inicializa todos os stages com 0
    const result = {
      desconexao: 0,
      recentes: 0,
      prospeccao: 0,
      nutricao: 0,
      engajamento: 0,
      coleta: 0,
      agendamento: 0,
      atendimento: 0
    }

    // Mapeia os dados retornados do backend
    data.forEach(item => {
      const mappedKey = bucketMapping[item.bucket]
      if (mappedKey && item.users) {
        // Conta usuários que estão no projeto
        const usersInProject = item.users.filter(userId => 
          usersProject?.some(user => user?.id === userId)
        )
        result[mappedKey] = usersInProject.length
      }
    })

    return result
  } catch (error) {
    console.error("Erro ao buscar dados do beneficiário", error)
    return {}
  }
}
